import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface UnsavedChangesDialogProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  title?: string
  description?: string
  cancelText?: string
  confirmText?: string
}

export function UnsavedChangesDialog({
  open,
  onConfirm,
  onCancel,
  title = 'Unsaved Changes',
  description = 'You have unsaved changes that will be lost if you leave this page. Are you sure you want to continue?',
  cancelText = 'Stay Here',
  confirmText = 'Discard Changes',
}: Readonly<UnsavedChangesDialogProps>) {
  const handleConfirm = () => {
    onConfirm()
  }

  const handleCancel = () => {
    onCancel()
  }

  return (
    <Dialog
      open={open}
      modal={true}
      onOpenChange={open => {
        if (!open) {
          handleCancel()
        }
      }}
      aria-labelledby="unsaved-changes-title"
      aria-describedby="unsaved-changes-desc"
    >
      <DialogContent
        className="max-w-md"
        onPointerDownOutside={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle id="unsaved-changes-title">{title}</DialogTitle>
          <DialogDescription id="unsaved-changes-desc">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleCancel}
            aria-label="Stay on current page"
          >
            {cancelText}
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            aria-label="Discard changes and leave"
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
